"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JobProvider = void 0;

var _jobStatusResponse = require("./response-parsers/job-status-response");

var _listJobsResponse = require("./response-parsers/list-jobs-response");

var _newJobResponse = require("./response-parsers/new-job-response");

var _assert = require("../../../utils/assert");

var _types = require("../../../types");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var JobProvider =
/*#__PURE__*/
function () {
  function JobProvider(client) {
    _classCallCheck(this, JobProvider);

    _assert.assert.isRequired({
      client: client
    }, 'JobProvider::constructor');

    this._client = client;
  }

  _createClass(JobProvider, [{
    key: "list",
    value: function list(imageId, macroId) {
      _assert.assert.isRequired({
        imageId: imageId
      }, 'JobProvider::list');

      var data = {
        ImageId: imageId
      };

      if (macroId) {
        data.MacroId = macroId;
      }

      return this._client.request({
        methodName: 'ListJobs',
        data: data,
        parseResponseDelegate: _listJobsResponse.createJobListResponse
      });
    }
  }, {
    key: "getJobStatus",
    value: function getJobStatus(jobQueueId) {
      _assert.assert.isRequired({
        jobQueueId: jobQueueId
      }, 'JobProvider::getJobStatus');

      return this._client.request({
        methodName: 'ListJobs',
        data: {
          JobQueueId: jobQueueId
        },
        parseResponseDelegate: _jobStatusResponse.createJobStatusResponse
      });
    }
  }, {
    key: "add",
    value: function add(_ref) {
      var imageId = _ref.imageId,
          inputAnnotationId = _ref.inputAnnotationId,
          outputAnnotationId = _ref.outputAnnotationId,
          macroId = _ref.macroId,
          _ref$priority = _ref.priority,
          priority = _ref$priority === void 0 ? 1 : _ref$priority,
          _ref$createMarkup = _ref.createMarkup,
          createMarkup = _ref$createMarkup === void 0 ? true : _ref$createMarkup;

      _assert.assert.isRequired({
        imageId: imageId,
        inputAnnotationId: inputAnnotationId,
        outputAnnotationId: outputAnnotationId,
        macroId: macroId,
        priority: priority,
        createMarkup: createMarkup
      }, 'JobProvider::addNewJob');

      return this._client.request({
        methodName: 'AddNewJob',
        data: {
          AddJobInfo: {
            ImageId: imageId,
            InputAnnotationId: inputAnnotationId,
            OutputAnnotationId: outputAnnotationId,
            MacroId: macroId,
            Priority: priority,
            CreateMarkup: _types.BooleanAsNumber.Out(createMarkup)
          }
        },
        parseResponseDelegate: _newJobResponse.createNewJobResponse
      });
    }
  }, {
    key: "cancel",
    value: function cancel(jobQueueId) {
      _assert.assert.isRequired({
        jobQueueId: jobQueueId
      }, 'JobProvider::cancel');

      return this._client.request({
        methodName: 'CancelJob',
        data: {
          JobId: jobQueueId
        }
      });
    }
  }]);

  return JobProvider;
}();

exports.JobProvider = JobProvider;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/image-analysis/jobs/JobProvider.js
// module id = 225
// module chunks = 0